import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ZoneOption } from "../../../../../shared/geo/zone-option";
import { type FailedDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Loads the coverage catalogue backing the "Registrar otra dirección" form. */
export const loadZones = createAsyncThunk<
  ZoneOption[],
  void,
  { dispatch: FailedDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_ZONES, async (_, { extra }) => {
  return extra.failedDeliveryRepo.listZoneOptions();
});
